define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LE = require("app");

    var FILTER_ENUM = {
        NAME: "name",
        PARENT_GROUP: "parentGroup",
        MANAGERS: "managers"
    };

    var EMPTY_FILTERS = {};
    EMPTY_FILTERS[FILTER_ENUM.NAME] = [];
    EMPTY_FILTERS[FILTER_ENUM.PARENT_GROUP] = [];
    EMPTY_FILTERS[FILTER_ENUM.MANAGERS] = [];

    var AgentGroupsMoveGridModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsMoveGridModel = BaseModel.extend({
            defaults: {
                filters: EMPTY_FILTERS,
                comparators:{
                    "name":"name",
                    "parentGroup":"parentGroup",
                    "members":"members",
                    "subGroups":"subGroups"
                }
            },

            initialize: function(attr, options) {
                this.agentGroupId = options.agentGroupId;
            },

            pluck: function (_model) {
                return true;
            },

            setFilterValue: function(filterName, filterValue){
                if(!_.isUndefined(this.get("filters." + filterName))){
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function(filterName){
                return this.get("filters." + filterName);
            },
            getFilters: function(){
                return this.get("filters");
            },
            setFilters: function(filters){
                this.set("filters",filters);
            },
            resetFilters: function() {
                this.setFilters(EMPTY_FILTERS);
            },
            getAgentGroupId: function() {
                return this.agentGroupId;
            },

            predicate: function (model) {
                var modelIsInSelection = true;
                var passFilter;

                var privileges = {viewAll: LEUserManagement.hasEntireAgentGroupTreePrivilege()};
                if (!privileges.viewAll) {
                    var groupsUnderLoggedInUser = LEUserManagement.getDataManager().getData(LEUserManagement.getDataManager().getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var groupToMove = LEUserManagement.getDataManager().getData(LEUserManagement.getDataManager().getEntities().AGENT_GROUP).get(this.agentGroupId);
                    var parentOfThisGroup = groupToMove.getParentGroupId();
                    passFilter = model.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser) || model.id === parentOfThisGroup;
                    modelIsInSelection = modelIsInSelection && passFilter;
                }


                //check if model name is in selection:
                if(!_.isEmpty(this.get("filters.name"))) {
                    passFilter = false;
                    _.each(this.get("filters.name"), function (name) {
                        if (model.getName() === name) {
                            passFilter = true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model parent group name is in selection:
                if(!_.isEmpty(this.get("filters.parentGroup"))) {
                    passFilter = false;
                    _.each(this.get("filters.parentGroup"), function (parentGroupId) {
                        if (model.getParentGroupId() === parentGroupId) {
                            passFilter = true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                if(!_.isEmpty(this.get("filters.managers"))) {
                    passFilter = _.intersection(model.getManagers(), this.get("filters.managers")).length > 0;

                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                return modelIsInSelection;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    AgentGroupsMoveGridModel.FILTER_ENUM = FILTER_ENUM;

    return AgentGroupsMoveGridModel;
});

